// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__m4qGr","title":"Info_title__1jz8P","selects":"Info_selects__29Wm3","requiredAsterisk":"Info_requiredAsterisk__1x9RG"};